/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Mobile Nav Bar Tab.
 */

import React from "react";
import { NavLink } from "react-router-dom";

export const MobileNavBarTab = ({ path, label, handleClick }) => {
  return (
    <NavLink
      onClick={handleClick}
      to={path}
      end
      className={({ isActive }) =>
        "MobileNavBar__tab " + (isActive ? "MobileNavBar__tab--active" : "")
      }
    >
      {label}
    </NavLink>
  );
};
